import React from "react";
class Processing extends React.Component {
  render() {
    return <div>Processing...</div>;
  }
}

export default Processing;
